// pages/Start.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderPlus } from 'lucide-react';
import Navbar from '../components/Navbar';


const Start = () => {
  
  const navigate = useNavigate();

  return (
    <div className="min-h-screen font-sans antialiased">
      <Navbar />
      
      <div className="px-4 md:px-8 lg:px-16 py-12 max-w-4xl mx-auto">
        <div className="text-left mb-12">
          <h1 className="text-4xl font-bold mb-6">
            Welcome to Your Design Journey
          </h1>
          <p className="text-xl text-gray-700 mb-4">
            Transform your creative ideas into stunning prototypes with our 
            AI-powered design tool. We're here to help you bring your vision to life.
          </p>
          <p className="text-xl text-gray-700">
            Get started by creating your first project. Our intuitive interface 
            will guide you through the process, making prototyping faster and 
            more enjoyable than ever.
          </p>
        </div>

        <div className="flex justify-left">
          <button
            onClick={() => navigate('/new-project')}
            className="p-8 bg-black text-white rounded-lg hover:bg-gray-800 
              transition-colors duration-200 flex flex-col items-center"
          >
            <FolderPlus size={48} className="mb-2" />
            <span className="text-lg">New Project</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Start;